import React from "react";
import FaqsComp from "../FaqsComp";
import classes from "./ServiceCTASection.module.css";
import { Link } from "react-router-dom";

export default function ServiceCTASection({
  imageSrc,
  imageAlt = "cta section image",
  title = "Dedicated Billing Consultant for Your Clinic’s RCM",
  description = "Medical billing can be prone to errors, delays, and inefficiencies that affect your cash flow and profitability. PSP RCM's billing associates streamline your clinic’s billing process by taking care of the entire RCM with real-time reports and analytics.",
  btnText = "Let's Connect",
}) {
  return (
    <section className={classes.section}>
      <div className={`container ${classes.shell}`}>
        <div className={classes.mediaColumn}>
          <div className={classes.imageCard}>
            <img className={classes.image} src={imageSrc} alt={imageAlt} />
          </div>
        </div>

        <div className={classes.contentColumn}>
          <h2>{title}</h2>
          <p>{description}</p>
          <Link to="/contact-us" className={classes.ctaButton}>
            {btnText}
          </Link>
        </div>
      </div>
    </section>
  );
}
